(ns machtfit.translation
  (:require [cljs-time.format :as time.format]
            [clojure.string :as str]
            [clojure.walk :as walk]
            [machtfit.language :as language]
            [re-frame.core :as rf]))

(defonce ^:dynamic ^:private *messages* {})

(defn set-messages! [language messages]
  (set! *messages* (assoc *messages* language messages)))

(defn- upper-case? [s]
  (= s (str/upper-case s)))

(defn- upper-case-first [s]
  (str (str/upper-case (first s)) (str/join (rest s))))

(defn- place-holder-value
  "`place-holder` is the whole placeholder expression, e.g. `{team}`
  `name` is just the placeholder name, e.g. `team`"
  [[place-holder name] place-holders]
  (let [lower-case-name (str/lower-case name)]
    (if (contains? place-holders lower-case-name)
      (cond-> (place-holders lower-case-name)
        (upper-case? (first name)) upper-case-first)
      place-holder)))

(defn replace-place-holders [s place-holders]
  (str/replace s #"\{([^}]+)\}" #(place-holder-value % place-holders)))

(defn- replace-in-hiccup [hiccup place-holders]
  (walk/postwalk #(cond-> %
                    (string? %) (replace-place-holders place-holders))
                 hiccup))

(defn tr [message]
  (let [language @(rf/subscribe [:get [:language]])]
    (-> language
        language/coerce-language
        *messages*
        (or {})
        (get message message))))

(defn tr-with-place-holders [message place-holders]
  (-> message
      tr
      (replace-in-hiccup place-holders)))

(defn translate [messages language]
  (or (get messages (language/coerce-language language))
      (get messages language/default-language)))

(defn t
  "Select the localized Hiccup/string from a map
  of language keys to Hiccup/strings."
  [messages]
  (translate messages @(rf/subscribe [:get [:language]])))

(defn tn [singular plural number]
  (if (= 1 number)
    (t singular)
    (t plural)))

(defn tr-raw [data language]
  (cond
    (map? data) (let [translated (get data language)]
                  (if (str/blank? translated)
                    (get data :de)
                    translated))
    :else (str data)))

(defn str-tr [& strs]
  {:de (str/join (map #(tr-raw % :de) strs))
   :en (str/join (map #(tr-raw % :en) strs))})

(defn trp-with-place-holders [message place-holders]
  (-> message
      t
      (replace-in-hiccup place-holders)))

(defn trn [singular plural number]
  (if (= 1 number) (tr singular) (tr plural)))

(defn trnp [singular plural number]
  (if (= 1 number) (t singular) (t plural)))

(def ^:private formatter-date-de (time.format/formatter "d.M.yyyy"))

(def ^:private formatter-date-en (time.format/formatter "MMMM do, yyyy"))

(defn format-date [date]
  (->> date
       (time.format/unparse (case @(rf/subscribe [:get [:language]])
                              :en formatter-date-en
                              formatter-date-de))))
